// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2XPTe","col":"CardReaderDesc_col__mYnYC","label":"CardReaderDesc_label__1prJJ"};